import { Reducer } from 'redux';
import ISiteReliabilityState from '../state/SiteReliabilityState';
import { SiteReliabilityAction, SiteReliabilityActionTypes } from '../actions/SiteReliabilityActions';
import { IExperimentStatusResponse, IPrometheusApiResponse,IExperimentResponsePayload } from '../../models/SiteReliabilityModels';

export const initialState: ISiteReliabilityState = {
  error: '',
  loading: false,
  experimentId: undefined,
  experimentStatus: undefined,
  prometheusData: undefined,
  faultDetails : undefined,
  fiStatusString: '',
};

export const siteReliabilityReducers: Reducer<ISiteReliabilityState> = (state = initialState, action: SiteReliabilityAction) => {
  switch (action.type) {
    case SiteReliabilityActionTypes.TRIGGER_EXPERIMENT_START:
      return {
        ...state,
        loading: true,
      };
    case SiteReliabilityActionTypes.TRIGGER_EXPERIMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        faultDetails: action.data as IExperimentResponsePayload
      };
    case SiteReliabilityActionTypes.TRIGGER_EXPERIMENT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.data as Error,
      };
    
    case SiteReliabilityActionTypes.EXPERIMENT_STATUS_START:
      return {
        ...state,
        loading: true,
      };
    case SiteReliabilityActionTypes.EXPERIMENT_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        experimentStatus: action.data as IExperimentStatusResponse
      };
    case SiteReliabilityActionTypes.EXPERIMENT_STATUS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.data as Error,
      };

    case SiteReliabilityActionTypes.PROMETHEUS_API_START:
        return {
            ...state,
            loading: true,
        };
    case SiteReliabilityActionTypes.PROMETHEUS_API_SUCCESS:
        return {
            ...state,
            loading: false,
            prometheusData: action.data as IPrometheusApiResponse
        };
    case SiteReliabilityActionTypes.PROMETHEUS_API_ERROR:
        return {
            ...state,
            loading: false,
            error: action.data as Error,
        };
    case SiteReliabilityActionTypes.GET_FINJ_STATUS_START:
        return {
            ...state,
            loading: true,
        };
    case SiteReliabilityActionTypes.GET_FINJ_STATUS_SUCCESS:
        return {
            ...state,
            loading: false,
            fiStatusString: action.data as string
        };
    case SiteReliabilityActionTypes.GET_FINJ_STATUS_ERROR:
        return {
            ...state,
            loading: false,
            error: action.data as Error,
        };
    
    default:
      return state;
  }
};
